/**
 * Orichi Quantity Check for regular products (non-string-service)
 * Watches Orichi error messages and enables/disables buy buttons accordingly
 */
(function() {
  // Skip if string service product (handled by string-service-charge.js)
  if (document.querySelector('[data-string-dropdown-select]')) {
    console.log('[orichi-quantity-check] Skipping - string service product detected');
    return;
  }

  // PDP buttons
  const buyCartBtn = document.querySelector('[data-buy-cart-btn]');
  const buyNowBtn = document.querySelector('[data-buy-now-cart]');
  const buyNowEmptyBtn = document.querySelector('[data-buy-now-empty-btn]');

  // Sticky popup (bottom sheet) buttons
  const stickyCartBtn = document.querySelector('[data-sticky-atc-cart-button]');
  const stickyCartBtnDisabled = document.querySelector('[data-sticky-atc-cart-button--disabled]');

  if (!buyCartBtn && !buyNowBtn && !buyNowEmptyBtn && !stickyCartBtn) {
    console.log('[orichi-quantity-check] No buy buttons found');
    return;
  }

  console.log('[orichi-quantity-check] Found buttons:', {
    buyCartBtn: !!buyCartBtn,
    buyNowBtn: !!buyNowBtn,
    buyNowEmptyBtn: !!buyNowEmptyBtn,
    stickyCartBtn: !!stickyCartBtn,
    stickyCartBtnDisabled: !!stickyCartBtnDisabled
  });

  /**
   * Check if Orichi error message is visible
   */
  const hasOrichiError = () => {
    const quantityError = document.querySelector('.orichi-quantity-textError');
    if (!quantityError) {
      console.log('[orichi-quantity-check] No .orichi-quantity-textError element found');
      return false;
    }

    const errorText = quantityError.textContent?.trim() || '';
    const style = getComputedStyle(quantityError);

    const hasError = errorText !== '' &&
           style.display !== 'none' &&
           style.visibility !== 'hidden';

    console.log('[orichi-quantity-check] Error check:', {
      errorText: errorText.substring(0, 50),
      display: style.display,
      visibility: style.visibility,
      hasError
    });

    return hasError;
  };

  /**
   * Move Orichi error element before quantity-wrapper so it appears between price/stock and quantity
   */
  const repositionOrichiError = () => {
    // Orichi가 생성한 원본만 찾기 (우리가 만든 클론/에러 요소 제외)
    const errorEls = document.querySelectorAll('.orichi-quantity-textError:not([data-orichi-clone]):not([data-sticky-cart-error])');
    if (errorEls.length === 0) return;

    // 원본 에러 요소 (Orichi가 생성한 것)
    const originalError = errorEls[0];

    // 1) 메인 PDP에 위치시키기 (기존 로직)
    const form = originalError.closest('form') || originalError.closest('.product-area__details');
    if (form) {
      const actionContainer = form.querySelector('.product-detail__form__options--with-quantity');
      if (actionContainer) {
        const quantityWrapper = actionContainer.querySelector('.quantity-wrapper');
        if (quantityWrapper && (originalError.parentElement !== actionContainer || quantityWrapper.previousElementSibling !== originalError)) {
          actionContainer.insertBefore(originalError, quantityWrapper);
        }
      }
    }

    // 2) 바텀시트에 클론 동기화
    const stickyForm = document.querySelector('[data-sticky-atc-form]');
    if (!stickyForm) return;

    const stickyActionContainer = stickyForm.querySelector('.product-detail__form__options--with-quantity');
    if (!stickyActionContainer) return;

    const stickyQuantityWrapper = stickyActionContainer.querySelector('.quantity-wrapper');
    if (!stickyQuantityWrapper) return;

    const stickyPrice = stickyActionContainer.querySelector('.as-productStickyAtc__price');

    // data-orichi-clone으로 우리 클론만 식별 (Orichi가 주입한 요소와 구분)
    let clonedError = stickyActionContainer.querySelector('[data-orichi-clone]');

    if (!clonedError) {
      clonedError = document.createElement('div');
      clonedError.className = 'orichi-quantity-textError';
      clonedError.setAttribute('data-orichi-clone', 'true');
      // 합계 바로 뒤에 삽입
      if (stickyPrice) {
        stickyPrice.after(clonedError);
      } else {
        stickyActionContainer.insertBefore(clonedError, stickyQuantityWrapper);
      }
    }

    // Orichi가 바텀시트에 직접 주입한 span 에러 숨기기 (클론으로 대체)
    stickyActionContainer.querySelectorAll('.orichi-quantity-textError:not([data-orichi-clone]):not([data-sticky-cart-error])').forEach(el => {
      el.style.setProperty('display', 'none', 'important');
    });

    // 원본 내용 및 표시 상태 동기화
    const errorText = originalError.textContent?.trim() || '';
    const computedDisplay = getComputedStyle(originalError).display;
    const isVisible = errorText !== '' && computedDisplay !== 'none';

    clonedError.textContent = errorText;
    clonedError.style.display = isVisible ? 'block' : 'none';
    clonedError.style.setProperty('order', '-3', 'important');
    clonedError.style.setProperty('flex', '0 0 100%', 'important');
    clonedError.style.setProperty('color', '#CE0E2D', 'important');
    stickyQuantityWrapper.style.removeProperty('order');
  };

  /**
   * Update button states based on Orichi error
   */
  const updateButtonStates = () => {
    repositionOrichiError();
    const hasError = hasOrichiError();

    console.log('[orichi-quantity-check] updateButtonStates - hasError:', hasError);

    // Check if variant is sold out
    const variantSelect = document.querySelector('select[name="id"].original-selector, select.original-selector');
    const selectedOption = variantSelect?.options[variantSelect?.selectedIndex];
    const inventory = selectedOption ? parseInt(selectedOption.getAttribute('data-inventory') || '0', 10) : 0;
    const isSoldOut = inventory <= 0;

    console.log('[orichi-quantity-check] Inventory check:', { inventory, isSoldOut });

    // PDP buttons
    if (buyCartBtn) {
      if (hasError || isSoldOut) {
        buyCartBtn.disabled = true;
        buyCartBtn.style.opacity = '0.5';
        buyCartBtn.style.cursor = 'not-allowed';
        console.log('[orichi-quantity-check] buyCartBtn disabled');
      } else {
        buyCartBtn.disabled = false;
        buyCartBtn.style.opacity = '';
        buyCartBtn.style.cursor = '';
        console.log('[orichi-quantity-check] buyCartBtn enabled');
      }
    }

    if (buyNowBtn) {
      if (hasError || isSoldOut) {
        buyNowBtn.disabled = true;
        buyNowBtn.style.opacity = '0.5';
        buyNowBtn.style.cursor = 'not-allowed';
      } else {
        buyNowBtn.disabled = false;
        buyNowBtn.style.opacity = '';
        buyNowBtn.style.cursor = '';
      }
    }

    if (buyNowEmptyBtn) {
      if (hasError) {
        buyNowEmptyBtn.disabled = true;
        buyNowEmptyBtn.style.opacity = '0.5';
        buyNowEmptyBtn.style.cursor = 'not-allowed';
      } else {
        buyNowEmptyBtn.disabled = false;
        buyNowEmptyBtn.style.opacity = '';
        buyNowEmptyBtn.style.cursor = '';
      }
    }

    // Re-query sticky popup buttons (they may be dynamically loaded)
    const currentStickyCartBtn = document.querySelector('[data-sticky-atc-cart-button]');
    const currentStickyCartBtnDisabled = document.querySelector('[data-sticky-atc-cart-button--disabled]');

    // Update sticky popup (bottom sheet) buttons using CSS class
    if (currentStickyCartBtn) {
      if (hasError || isSoldOut) {
        currentStickyCartBtn.classList.add('orichi-quantity-limited');
        currentStickyCartBtn.disabled = true;
        console.log('[orichi-quantity-check] stickyCartBtn disabled');
      } else {
        currentStickyCartBtn.classList.remove('orichi-quantity-limited');
        currentStickyCartBtn.disabled = false;
        console.log('[orichi-quantity-check] stickyCartBtn enabled');
      }
    }


    if (currentStickyCartBtnDisabled) {
      if (hasError || isSoldOut) {
        currentStickyCartBtnDisabled.classList.remove('orichi-quantity-limited');
        currentStickyCartBtnDisabled.style.display = 'block';
        console.log('[orichi-quantity-check] stickyCartBtnDisabled shown');
      } else {
        currentStickyCartBtnDisabled.classList.add('orichi-quantity-limited');
        currentStickyCartBtnDisabled.style.display = '';
        console.log('[orichi-quantity-check] stickyCartBtnDisabled hidden');
      }
    }
  };

  /**
   * Trigger Orichi to recalculate by dispatching quantity input events
   */
  const triggerOrichiRecalculation = () => {
    const quantityInput = document.querySelector('input[name="quantity"]');
    if (quantityInput) {
      console.log('[orichi-quantity-check] Triggering Orichi recalculation');
      quantityInput.dispatchEvent(new Event('focus', { bubbles: true }));
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
      quantityInput.dispatchEvent(new Event('blur', { bubbles: true }));
    }
  };

  /**
   * Refresh after cart update - fetch cart, trigger Orichi recalculation and update buttons
   */
  const refreshAfterCartUpdate = () => {
    console.log('[orichi-quantity-check] refreshAfterCartUpdate called');

    // First fetch the current cart to ensure Orichi has the latest data
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        console.log('[orichi-quantity-check] Cart fetched, item count:', cart.item_count);

        // Give Orichi time to notice the cart change
        setTimeout(() => {
          // Trigger Orichi to recalculate
          triggerOrichiRecalculation();

          // Wait for Orichi to update its error message, then update button states
          setTimeout(() => {
            console.log('[orichi-quantity-check] Updating button states after Orichi recalculation');
            updateButtonStates();

            // Retry once more after additional delay in case Orichi is slow
            setTimeout(() => {
              console.log('[orichi-quantity-check] Retry updating button states');
              updateButtonStates();
            }, 500);
          }, 300);
        }, 100);
      })
      .catch(error => {
        console.error('[orichi-quantity-check] Error fetching cart:', error);
        // Still try to update even if fetch fails
        triggerOrichiRecalculation();
        setTimeout(updateButtonStates, 300);
      });
  };

  /**
   * Watch for Orichi error element changes
   */
  const observeOrichiError = () => {
    const quantityError = document.querySelector('.orichi-quantity-textError');

    if (!quantityError) {
      console.log('[orichi-quantity-check] Waiting for .orichi-quantity-textError element...');
      // Orichi might not have loaded yet, retry
      setTimeout(observeOrichiError, 500);
      return;
    }

    console.log('[orichi-quantity-check] Found .orichi-quantity-textError element');

    // Initial check
    updateButtonStates();

    // Watch for changes
    const observer = new MutationObserver(() => {
      console.log('[orichi-quantity-check] MutationObserver triggered');
      updateButtonStates();
    });

    observer.observe(quantityError, {
      childList: true,
      characterData: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class']
    });

    // Watch parent too (visibility changes)
    const parent = quantityError.parentElement;
    if (parent) {
      const parentObserver = new MutationObserver(() => {
        console.log('[orichi-quantity-check] Parent MutationObserver triggered');
        updateButtonStates();
      });
      parentObserver.observe(parent, {
        childList: true,
        attributes: true,
        attributeFilter: ['style', 'class']
      });
    }

    console.log('[orichi-quantity-check] Started watching .orichi-quantity-textError');
  };

  // Also update on quantity input change (debounced)
  const quantityInput = document.querySelector('input[name="quantity"]');
  if (quantityInput) {
    let debounceTimer;
    const handleQuantityChange = () => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        console.log('[orichi-quantity-check] Quantity input changed');
        // Wait for Orichi to update its error message
        setTimeout(updateButtonStates, 150);
      }, 200);
    };

    quantityInput.addEventListener('change', handleQuantityChange);
    quantityInput.addEventListener('input', handleQuantityChange);
    console.log('[orichi-quantity-check] Added quantity input listeners');
  }

  // Sync error state when bottom sheet opens (multiple delays for Orichi timing)
  const mobileAtcBtn = document.querySelector('[data-mobile-atc]');
  if (mobileAtcBtn) {
    mobileAtcBtn.addEventListener('click', () => {
      console.log('[orichi-quantity-check] Bottom sheet opened');
      setTimeout(updateButtonStates, 100);
      setTimeout(updateButtonStates, 500);
      setTimeout(updateButtonStates, 1000);
    });
  }

  // Listen to cart update events
  if (window.jQuery) {
    window.jQuery(document).on('cart:updated', () => {
      console.log('[orichi-quantity-check] cart:updated event received');
      setTimeout(refreshAfterCartUpdate, 300);
    });
  }

  document.addEventListener('theme:cartchanged', () => {
    console.log('[orichi-quantity-check] theme:cartchanged event received');
    setTimeout(refreshAfterCartUpdate, 300);
  });

  // Also listen for successful add to cart from theme.js
  document.addEventListener('ajaxProduct:added', () => {
    console.log('[orichi-quantity-check] ajaxProduct:added event received');
    setTimeout(refreshAfterCartUpdate, 300);
  });

  // Start observing
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(observeOrichiError, 100);
    });
  } else {
    setTimeout(observeOrichiError, 100);
  }

  console.log('[orichi-quantity-check] Initialized for regular product');
})();
